import { useEffect, useState, useCallback } from "react";
import SFSlider from "../../../slider";
import SFTypography from "../../../typography";
import { SFStack } from "../../../grid";

const SliderRenderer = ({ config, generatedFilter, onChange, colDef }) => {
  const [configSlider, setConfigSlider] = useState({ loading: true });

  //Before we set the new values, we need to check that are valid
  const validValues = useCallback((values) => {
    //If the values object is not an array, they are no valid
    if (!Array.isArray(values)) {
      return false;
    }

    //If the array length is 0: we don't have selected any value, in that case the config values are the boundaries
    //If the array length is 2: we have selected values, in that case the generated values are the boundaries
    //In other case, they are no valid
    if (values.length !== 0 && values.length !== 2) {
      return false;
    }

    return true;
  }, []);

  //We separate change and changeComitted to avoid multiple API calls while we are changing the value
  const handleChange = (event, newValues) => {
    if (validValues(newValues)) {
      setConfigSlider((prev) => ({ ...prev, values: newValues }));
    }
  };
  const handleChangeCommitted = (event, newValues) => {
    if (validValues(newValues)) {
      onChange(newValues);
    }
  };

  //Every time the values change, we have to update the min and max thresholds in the Slider
  //and, in case we have selected values, we have to update the edge values
  useEffect(() => {
    if (!validValues(generatedFilter)) {
      return;
    }
    //If we don't have filter values, then we don't have to do anything
    if (config.values.length === 0) {
      return;
    }
    // Calculate the min and max values from the availables values
    const min = Math.min(...config.values);
    const max = Math.max(...config.values);

    const selectedValues = [
      generatedFilter.length > 0 && generatedFilter[0] !== undefined
        ? generatedFilter[0]
        : min,
      generatedFilter.length > 0 && generatedFilter[1] !== undefined
        ? generatedFilter[1]
        : max,
    ];

    //We set the new values in the Slider
    setConfigSlider({ min, max, values: selectedValues });
  }, [config.values]);

  //if slider is loading which means we are setting the initial values, we don't render anything
  if (configSlider.loading) {
    return null;
  }

  return (
    <SFStack direction="row" spacing={3} alignItems="center">
      <SFTypography variant="bold">{configSlider.min}</SFTypography>
      <SFSlider
        //if step is defined in filterParams then we set it, otherwise we set 1
        step={colDef?.filterParams?.step ?? 1}
        value={configSlider.values}
        min={configSlider.min}
        max={configSlider.max}
        onChangeCommitted={handleChangeCommitted}
        onChange={handleChange}
        valueLabelDisplay="auto"
      />
      <SFTypography variant="bold">{configSlider.max}</SFTypography>
    </SFStack>
  );
};

export default SliderRenderer;
